import { z } from 'zod';

export const vehicleNameSchema = z.string().trim().max(255, 'Cannot contain more than 255 characters');
export const requiredVehicleNameSchema = z
    .string()
    .trim()
    .min(1, 'Vehicle name is required')
    .max(255, 'Cannot contain more than 255 characters');
export const vehicleLicensePlateSchema = z.string().trim().max(50, 'Cannot contain more than 50 characters');

export const normalizeVehicleFields = ({ name, licensePlate }: { name: string; licensePlate: string }) => ({
    name: name.trim(),
    license_plate: licensePlate.trim() || null,
});
